export type DataLayerParams = Record<string, unknown>;

let previousKeys: string[] = [];

function getDataLayer(): unknown[] {
  window.dataLayer = window.dataLayer ?? [];

  return window.dataLayer;
}

/**
 * GTM merges every push into one persistent model, so a parameter from an earlier event
 * silently leaks into the next one unless it is cleared first.
 */
export function pushEvent(event: string, params: DataLayerParams = {}): void {
  const dataLayer = getDataLayer();

  if (previousKeys.length > 0) {
    dataLayer.push(
      Object.fromEntries(previousKeys.map(key => [key, undefined])),
    );
  }

  previousKeys = Object.keys(params);
  dataLayer.push({ event, ...params });
}
